import { render, staticRenderFns } from "./part_list_select.vue?vue&type=template&id=23ff6c46"
import script from "./part_list_select.vue?vue&type=script&lang=js"
export * from "./part_list_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports